import { Target, Warning } from '@phosphor-icons/react';

import { Button } from '../ui/Button';
import pt from '../../locales/pt';
import {
  decimalToPtInput,
  potCycleDepositAmount,
  potRemainingAfterDeposit,
  potRemainingAmount,
} from '../../utils/quickExpensePots';
import { parsePtNumber } from '../../utils/money';

function Cell({ label, value }) {
  return (
    <div className="flex min-w-0 flex-1 flex-col gap-0.5">
      <p className="type-chip font-normal text-muted-foreground">{label}</p>
      <p className="type-display-stat text-card-foreground">{value}</p>
    </div>
  );
}

/** `.pen` `ds/card/vault-deposit-hints`. */
export function VaultDepositHints({ selectedPot, amount, validation, setAmount }) {
  const suggestedDeposit = potCycleDepositAmount(selectedPot);
  const remainingInPot = potRemainingAmount(selectedPot);
  const afterDeposit = potRemainingAfterDeposit(selectedPot, amount);
  const cycleContributed = Number(selectedPot?.cycle_contributed || 0);

  return (
    <div className="flex w-full flex-col gap-space-3 rounded-ds-lg border border-sage-border bg-sage-tint p-space-4">
      <div className="flex items-center gap-space-2">
        <Target className="h-4 w-4 shrink-0 text-sage-on-tint" aria-hidden />
        <p className="type-label text-sage-on-tint">{pt.quickExpense.potDepositHintsTitle}</p>
      </div>

      <div className="flex flex-col gap-space-3">
        <div className="flex gap-space-3">
          <Cell
            label={pt.quickExpense.potDepositRemainingCell}
            value={`${decimalToPtInput(remainingInPot) || '0,00'} €`}
          />
          <Cell
            label={pt.quickExpense.potDepositSuggestedCell}
            value={suggestedDeposit > 0 ? `${decimalToPtInput(suggestedDeposit)} €` : '—'}
          />
        </div>
        <div className="flex gap-space-3">
          <Cell
            label={pt.quickExpense.potDepositContributedCell}
            value={`${decimalToPtInput(cycleContributed) || '0,00'} €`}
          />
          <Cell
            label={pt.quickExpense.potDepositAfterCell}
            value={parsePtNumber(amount) > 0 ? `${decimalToPtInput(afterDeposit) || '0,00'} €` : '—'}
          />
        </div>
      </div>

      {validation.reason === 'over-remaining' ? (
        <div className="flex items-start gap-space-3 rounded-ds-lg border border-warning-500 bg-warning-tint p-space-3">
          <Warning size={18} className="shrink-0 text-warning-fg" aria-hidden />
          <div className="flex min-w-0 flex-1 flex-col gap-0.5">
            <p role="alert" className="type-body-sm font-semibold text-warning-fg">
              {pt.quickExpense.potDepositOverRemaining.replace(
                '{amount}',
                decimalToPtInput(remainingInPot) || '0,00',
              )}
            </p>
          </div>
        </div>
      ) : null}

      <div className="flex items-center gap-space-2">
        {suggestedDeposit > 0 ? (
          <Button
            type="button"
            variant="secondary"
            size="sm"
            onClick={() => setAmount(decimalToPtInput(suggestedDeposit))}
            className="flex-1 justify-center"
          >
            {pt.quickExpense.potDepositFillMonthly}
          </Button>
        ) : null}
        {remainingInPot > 0 ? (
          <Button
            type="button"
            variant="secondary"
            size="sm"
            onClick={() => setAmount(decimalToPtInput(remainingInPot))}
            className="flex-1 justify-center"
          >
            {pt.quickExpense.potDepositFillRemaining}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
